import React from 'react';
import { useTranslation } from '../../hooks/useTranslation';
import { PaymentStatus } from '@dutchinvoice/types';
import { motion } from 'framer-motion';

export type FilterStatus = PaymentStatus | 'all';

interface PaymentStatusFilterProps {
  currentFilter: FilterStatus;
  onFilterChange: (filter: FilterStatus) => void;
}

export const PaymentStatusFilter: React.FC<PaymentStatusFilterProps> = ({
  currentFilter,
  onFilterChange,
}) => {
  const { t } = useTranslation();

  const filters: FilterStatus[] = ['all', 'unpaid', 'paid', 'overdue', 'overdue_reminded'];

  const getFilterLabel = (filter: FilterStatus): string => {
    if (filter === 'all') return t('payment.filter.all');
    return t(`payment.status.${filter}`);
  };

  return (
    <div className="flex items-center gap-1 sm:gap-2 p-1 bg-gray-100/50 backdrop-blur-xl rounded-xl whitespace-nowrap min-w-full xs:min-w-0 sm:min-w-0 overflow-x-auto hide-scrollbar">
      {filters.map((filter) => (
        <button
          key={filter}
          onClick={() => onFilterChange(filter)}
          className={`relative flex-shrink-0 xs:flex-1 px-1.5 xs:px-2 sm:px-3 py-1.5 text-xs sm:text-sm font-medium rounded-lg transition-all duration-200 ${currentFilter === filter
            ? 'text-primary-700 bg-white shadow-sm'
            : 'text-gray-600 hover:text-primary-600 hover:bg-white/50'
            }`}
        >
          {currentFilter === filter && (
            <motion.div
              layoutId="activeFilter"
              className="absolute inset-0 bg-white rounded-lg shadow-sm"
              transition={{ type: "spring", bounce: 0.2, duration: 0.6 }}
            />
          )}
          <span className="relative">
            {getFilterLabel(filter)}
          </span>
        </button>
      ))}
    </div>
  );
}; 